<div class="h-90" tabindex="-1" role="dialog" aria-labelledby="compabitibilityCheckerLabel">
  <div class="modal-dialog modal-dialog-centered h-100" role="document">
    <div class="modal-content">
      <div class="modal-body text-center d-flex align-items-center justify-content-center flex-column">
        <button type="button" class="close" aria-label="Close" (click)="dismiss()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.7141 10.2941C11.9024 10.4824 12.0082 10.7378 12.0082 11.0041C12.0082 11.2704 11.9024 11.5258 11.7141 11.7141C11.5258 11.9024 11.2704 12.0082 11.0041 12.0082C10.7378 12.0082 10.4824 11.9024 10.2941 11.7141L6.00409 7.41409L1.71409 11.7141C1.52579 11.9024 1.27039 12.0082 1.00409 12.0082C0.73779 12.0082 0.482395 11.9024 0.294092 11.7141C0.105788 11.5258 0 11.2704 0 11.0041C0 10.7378 0.105788 10.4824 0.294092 10.2941L4.59409 6.00409L0.294092 1.71409C0.105788 1.52579 -1.9841e-09 1.27039 0 1.00409C1.9841e-09 0.73779 0.105788 0.482395 0.294092 0.294092C0.482395 0.105788 0.73779 1.9841e-09 1.00409 0C1.27039 -1.9841e-09 1.52579 0.105788 1.71409 0.294092L6.00409 4.59409L10.2941 0.294092C10.4824 0.105788 10.7378 0 11.0041 0C11.2704 0 11.5258 0.105788 11.7141 0.294092C11.9024 0.482395 12.0082 0.73779 12.0082 1.00409C12.0082 1.27039 11.9024 1.52579 11.7141 1.71409L7.41409 6.00409L11.7141 10.2941Z"
              fill="#222221" />
          </svg>
        </button>

        <div class="bg-white">
          <p class="mb-2 modal-title d-flex align-items-center justify-content-center">
          Número de orden de compra vacío.
          </p>
          <p class="mb-3 modal-paragraph d-flex align-items-center justify-content-center">
            Puedes cerrar este aviso y completarlo o presionar "Continuar" para continuar con el pedido.
          </p>

          <div class="controls-checker d-flex justify-content-center">
            <button type="submit" (click)="ok()"      
              class="col-xs-12 col-sm-6 col-md-6 col-lg-6 center-xs mt-3 end-xs btn btn-primary">Continuar</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>